/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes/'
export default StyleSheet.create({

  content : {
    paddingLeft: 10,
    marginLeft: 0,
    paddingBottom: 10,
    minHeight  : 53, // 60,
  },
  boldText : {
    fontSize: 14,
    fontFamily: Fonts.style.font.bold,
  },
  shadow : {
    // shadowColor: '#000',
    // shadowOffset: { width: 0, height: 2 },
    // shadowOpacity: 0.9,
    // shadowRadius: 2,
    width: 30,
    height: 30
  },
  noShadow : {
   width: 30,
   height: 30
  },
  title : {
   fontSize: 16,

   fontFamily: Fonts.style.font.bold,
   color: Fonts.style.color.baseColor
  },
  subTitle : {
    fontFamily: Fonts.style.font.light,
    color: Fonts.style.color.baseColor
  },
  rightTitle : {
    textAlign: `right`,
    fontFamily: Fonts.style.font.regular,
    color: `black`
  },
  container: {
    flex: 1,
    flexDirection: 'row',
    minHeight  : 44,
    backgroundColor: '#FFFFFF',

    borderBottomWidth : 1,
    borderColor: 'grey'
  },
  left : {
    width: '70%',
    flexDirection: 'row',
    paddingLeft: 10,

    alignItems: 'center',

  },

  right : {
    width: '30%',
    flexDirection: 'row',
    minHeight  : 44,
    justifyContent: 'flex-end',



    alignItems: 'center'
  },
  img : {
    width: 30,
    height: 30,

  },

  avatar : {
    width: 30,
    height: 30,
    borderRadius: 15,
    marginRight: 5
  }
})
